export default "__VITE_ASSET__BSWrKj5J__"